'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Spinner = require('./Spinner');

Object.defineProperty(exports, 'Spinner', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Spinner).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/spinner/index.js
// module id = 606
// module chunks = 0